module.exports = __webpack_public_path__ + "img/festival.78944a6a.jpg";